﻿export class ActivityReturnValue {
    static $type = 'Web.ActivityReturnValue';

    name: string;
    value: any;
    retained: boolean;
}